import React from 'react';

const Podcasts = () => {
  const podcasts = [
    {
      name: 'YouTube Podcast 1',
      image: 'https://neelparekh.co/wp-content/uploads/2024/12/1200x1200bf-60.jpg',
      link: 'https://www.youtube.com/watch?v=F73uJmvypEo',
    },
    {
      name: 'YouTube Podcast 2',
      image: 'https://neelparekh.co/wp-content/uploads/2024/09/image-18-1080x675-1-e1726242132224.png',
      link: 'https://www.youtube.com/watch?v=BwylpxV0X3Q',
    },
    {
      name: 'YouTube Podcast 3',
      image: 'https://neelparekh.co/wp-content/uploads/2024/08/ab6765630000ba8a9c442925224a7b7da98cf5f0.jpg',
      link: 'https://www.youtube.com/watch?v=VLG_Gufvhn8',
    },
    {
      name: 'YouTube Podcast 4',
      image: 'https://neelparekh.co/wp-content/uploads/2024/08/ab6765630000ba8a396a1c37b569b02d32d16a38.jpg',
      link: 'https://www.youtube.com/watch?v=DEFD2Tsbyl4',
    },
    {
      name: 'The Elite Podcast',
      image: 'https://neelparekh.co/wp-content/uploads/2024/08/the-elite-podcast.jpg',
      link: 'https://www.youtube.com/watch?v=G9FwcXWP7b0',
    },
    {
      name: 'Owned and Operated Podcast',
      image: 'https://neelparekh.co/wp-content/uploads/2024/08/owned-and-operated-podcast.jpg',
      link: 'https://www.youtube.com/watch?v=S_XVudT-cAk',
    },
    {
      name: 'Untrapped Entrepreneur',
      image: 'https://neelparekh.co/wp-content/uploads/2024/08/untrapped-entrepreneur.png',
      link: 'https://www.youtube.com/watch?v=oWDfQo6p8kU',
    },
    {
      name: 'Tropical MBA',
      image: 'https://neelparekh.co/wp-content/uploads/2020/06/tropical.png',
      link: 'https://www.tropicalmba.com/remotelocalbusinesses/',
    },
    {
      name: 'Side Hustle School',
      image: 'https://neelparekh.co/wp-content/uploads/2021/01/side-hustle-school-scaled.jpg',
      link: 'https://sidehustleschool.com/episode/1452/',
    },
    {
      name: 'Upflip',
      image: 'https://neelparekh.co/wp-content/uploads/2024/02/upflip.webp',
      link: 'https://www.youtube.com/watch?v=kVyLriqFVdc&t=1324s',
    },
    {
      name: 'Zero to Travel',
      image: 'https://neelparekh.co/wp-content/uploads/2022/11/ZeroToTravelpodcast_A1.jpeg',
      link: 'https://zerototravel.com/neel-parekh/',
    },
    {
      name: 'Starter Story',
      image: 'https://neelparekh.co/wp-content/uploads/2021/05/StarterStory.png',
      link: 'https://www.starterstory.com/how-to-start-a-cleaning-service-for-airbnb',
    },
    {
      name: 'About Abroad',
      image: 'https://neelparekh.co/wp-content/uploads/2022/11/about-abroad.webp',
      link: 'https://podcasts.apple.com/us/podcast/about-abroad/id1551981038',
    },
    {
      name: 'The How of Business',
      image: 'https://neelparekh.co/wp-content/uploads/2022/11/the-how-of-busienss.webp',
      link: 'https://www.thehowofbusiness.com/378-neel-parekh-launching-maid-this/',
    },
    {
      name: 'Beyond 8',
      image: 'https://neelparekh.co/wp-content/uploads/2022/11/beyond-8.webp',
      link: 'https://podcasts.apple.com/us/podcast/leverage-your-network-for-lasting-business-growth-with/id1422002132?i=1000580893622',
    },
    {
      name: 'Podcast Series',
      image: 'https://neelparekh.co/wp-content/uploads/2021/10/avatars-000171172262-femo91-t500x500.jpg',
      link: 'https://www.youtube.com/watch?v=YP7auNvbdrA&t=29s',
    },
    {
      name: 'That Remote Life',
      image: 'https://neelparekh.co/wp-content/uploads/2020/06/that-remote-show.png',
      link: 'https://thatremotelife.com/episode10/',
    },
    {
      name: 'Misfits and Rejects',
      image: 'https://neelparekh.co/wp-content/uploads/2020/06/misfitsandrejects.png',
      link: 'https://www.misfitsandrejects.com/misfits-and-rejects-podcast/2020/7/20/mampr-episode-195-how-to-own-and-run-a-remote-local-cleaning-business-with-neel-parekh',
    },
    {
      name: 'Slick Talk',
      image: 'https://neelparekh.co/wp-content/uploads/2022/04/Slick-Talk.webp',
      link: 'https://podcasts.apple.com/us/podcast/maidthis-the-franchise-for-millennials-with-neel-parekh/id1365110128?i=1000551272304',
    },
    {
      name: 'Entrepreneur Truths',
      image: 'https://neelparekh.co/wp-content/uploads/2021/01/entrepreneur-truths-podcast.jpg',
      link: 'https://podcasts.apple.com/gb/podcast/neel-parekh-location-freedom-while-running-local-business/id1507170723',
    },
    {
      name: 'Minding Your Business',
      image: 'https://neelparekh.co/wp-content/uploads/2021/05/minding-your-business.jpeg',
      link: 'https://podcasts.apple.com/us/podcast/249-neel-parekh-founder-ceo-maidths-maidthis-franchise/id1270984117?i=1000510552954',
    },
    {
      name: 'Cracking the Cash Flow Code',
      image: 'https://neelparekh.co/wp-content/uploads/2022/03/cracking-the-code.png',
      link: 'https://player.fm/series/cracking-the-cash-flow-code/episode-337-how-to-document-and-systemize-every-little-piece-of-your-business-as-a-franchisor',
    },
    {
      name: 'Cleaning Franchise Podcast',
      image: 'https://neelparekh.co/wp-content/uploads/2023/04/313x0w-1.webp',
      link: 'https://podcasts.apple.com/us/podcast/how-to-start-a-cleaning-franchise-with-maidthis/id1545963091?i=1000608584882',
    },
    {
      name: 'Business with Beers',
      image: 'https://neelparekh.co/wp-content/uploads/2022/11/biz-iwth-beers.jpeg',
      link: 'https://businesswithbeers.buzzsprout.com/1714648/11667861-ep-102-operating-a-local-franchise-from-anywhere-in-the-world-with-neel-parekh',
    },
    {
      name: 'Rohan Gilkes Interview',
      image: 'https://neelparekh.co/wp-content/uploads/2020/06/rohan-gilkes.png',
      link: 'http://neelparekh.co/wp-content/uploads/2020/06/rohan_neel_interview.mp3',
    },
    {
      name: 'Side Hustle City',
      image: 'https://neelparekh.co/wp-content/uploads/2022/03/side-hustle-city.jpeg',
      link: 'https://www.buzzsprout.com/1350142/10149255',
    },
    {
      name: 'Grow Podcast',
      image: 'https://neelparekh.co/wp-content/uploads/2020/06/grow.png',
      link: 'https://www.youtube.com/watch?v=KlDspN49iB8',
    },
    {
      name: 'Home Biz Magazine',
      image: 'https://neelparekh.co/wp-content/uploads/2022/03/home-biz.jpeg',
      link: 'https://homebusinessmag.com/businesses/franchises/podcast-franchise-prenuer-success-secrets-in-owning-a-franchisor-business/',
    },
    {
      name: 'Success Made to Last',
      image: 'https://neelparekh.co/wp-content/uploads/2022/03/success-made-to-last-neel-parekh.jpeg',
      link: 'https://www.blogtalkradio.com/successmadetolast/2022/02/17/success-made-to-last-with-neel-parekh-founder-of-maidthis-franchise',
    },
    {
      name: 'Rude Growth',
      image: 'https://neelparekh.co/wp-content/uploads/2020/06/rudegrowth.png',
      link: 'https://open.spotify.com/episode/2lizx3yJEXpuwNr3mniiUB',
    },
    {
      name: 'Franchise Marketing Radio',
      image: 'https://neelparekh.co/wp-content/uploads/2022/03/franchise-marketing-radio.png',
      link: 'https://businessradiox.com/podcast/franchisemarketingradio/maidthis/',
    },
    {
      name: 'Libsyn Episode',
      image: 'https://neelparekh.co/wp-content/uploads/2022/04/EP-iG-Post-2.png',
      link: 'https://directory.libsyn.com/episode/index/id/22779611',
    },
    {
      name: "A Brother's Creed",
      image: 'https://neelparekh.co/wp-content/uploads/2022/11/a-brothers-creed.jpeg',
      link: 'https://www.youtube.com/watch?v=-7fbmnhvgFk&themeRefresh=1',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header Spacing */}
      <div className="h-20"></div>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-cream to-white py-16 md:py-24">
        <div className="section-container text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-dark-brown">
            You May Have Heard Me On...
          </h1>
          <p className="text-xl text-gray-brown max-w-3xl mx-auto">
            I've been featured on 30+ podcasts sharing insights about building location-independent
            businesses, franchising, and entrepreneurship. Here's where you can listen.
          </p>
        </div>
      </section>

      {/* Podcasts Grid */}
      <section className="py-16 md:py-24">
        <div className="section-container">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
            {podcasts.map((podcast, index) => (
              <a
                key={index}
                href={podcast.link}
                target="_blank"
                rel="noopener noreferrer"
                className="group"
              >
                <div className="card-hover bg-white rounded-2xl p-4 shadow-crisp border border-gray-100">
                  <div className="aspect-square rounded-xl overflow-hidden mb-4 bg-gray-100">
                    <img
                      src={podcast.image}
                      alt={podcast.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                  </div>
                  <h3 className="text-sm font-semibold text-dark-brown text-center group-hover:text-primary transition-colors">
                    {podcast.name}
                  </h3>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gradient-to-br from-cream to-white py-16 md:py-24">
        <div className="section-container text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-dark-brown">
            Want Me on Your Podcast?
          </h2>
          <p className="text-lg text-gray-brown mb-8 max-w-2xl mx-auto">
            I love sharing my journey and insights about location-independent businesses,
            franchising, and entrepreneurship. Let's connect!
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="https://twitter.com/NeelBParekh"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              DM on Twitter
            </a>
            <a
              href="https://www.linkedin.com/in/neelparekh/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary"
            >
              Connect on LinkedIn
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Podcasts;
